'use strict'

import Vue from 'vue'
import AppConfig from '@/config'

// api data 조회
const searchData = function (grid_options) {
  let id = grid_options.general.id;
  let url = grid_options.general.search;

  let serverPageInfo = {
    current : grid_options.general.PageInfo.current || 1,
    perPage : grid_options.general.PageInfo.perPage || 10
  }  

  if ( grid_options.grid_options.pager != true ) {
    serverPageInfo = {};
  }

  _.merge(serverPageInfo, grid_options.general.params);

  //$('#'+ id).alopexGrid("showProgress");

  //
  if ( grid_options.general.searchMethod != 'post' ) {

    Vue.httpClient
    .get(url, {params : serverPageInfo})
    .then((result) => {
      if ( result.data.result ) {
        serverPageInfo.dataLength = ( grid_options.grid_options.pager == true ) ? result.data.result.total : result.data.result.length;
        let list = ( grid_options.grid_options.pager == true ) ? result.data.result.list : result.data.result;
  
        $('#'+ id).alopexGrid('dataSet', list, serverPageInfo);
      } else {
        serverPageInfo.dataLength = 0;
  
        $('#'+ id).alopexGrid('dataSet', new Array(), serverPageInfo);
      }
    })
    .catch((error) => { })
    .then((result) => {
      //$('#'+ id).alopexGrid("hideProgress", true);
    })    

  } else {

    Vue.httpClient
    .post(url, serverPageInfo)
    .then((result) => {
      if ( result.data.result ) {
        serverPageInfo.dataLength = ( grid_options.grid_options.pager == true ) ? result.data.result.total : result.data.result.length;
        let list = ( grid_options.grid_options.pager == true ) ? result.data.result.list : result.data.result;
  
        $('#'+ id).alopexGrid('dataSet', list, serverPageInfo);
      } else {
        serverPageInfo.dataLength = 0;
  
        $('#'+ id).alopexGrid('dataSet', new Array(), serverPageInfo);
      }
    })
    .catch((error) => { })
    .then((result) => {
      //$('#'+ id).alopexGrid("hideProgress", true);
    })

  }

}
  
// paging event 설정
const setPagingEvent = function (grid_options) {
  let id = grid_options.general.id;

  // Page 버튼을 클릭했을때 데이터 바인딩
  $('#'+ id).on('pageSet', function(e){
    let evObj = AlopexGrid.parseEvent(e);

    grid_options.general.PageInfo.current = evObj.page;
    grid_options.general.PageInfo.perPage = evObj.pageInfo.perPage;

    searchData(grid_options);
  });
  // 우측하단 페이지당 데이터 개수 설정하는 이벤트 바인딩
  $('#'+ id).on('perPageChange', function(e){
    let evObj = AlopexGrid.parseEvent(e);

    grid_options.general.PageInfo.current = evObj.pageInfo.current;
    grid_options.general.PageInfo.perPage = evObj.perPage;    
  
    searchData(grid_options);
  });
}

// validtion 설정
const setEditInvalid = function (grid_options) {
  let id = grid_options.general.id;

  $('#'+ id).on('cellEditInvalid ', function(e){
    let evObj = AlopexGrid.parseEvent(e);
    let row = evObj.data._index.row;
    let col = evObj.mapping.columnIndex;

    $(this).alopexGrid('focusCell', { _index : { row : row } }, col);
  });    
}

// 행 추가 시 배경색 표시
const setDataAddColor = function (grid_options) {
  $('#'+ grid_options.general.id).on( 'dataAddEnd' , function (e) {
    let element = $(this).alopexGrid('rowElementGet', {_state:{added: true}});
    element.css("background-color", "#FAECC5");
  });
}

// 행 추가
const addRow = function (grid_options) {
  var defaultData = {};
  
  if ( grid_options.general.require_params ) {
    var options = grid_options.general;

    for ( var i in options.require_params.params ) {
      if ( options.params[options.require_params.params[i]] == null
              || $.trim(options.params[options.require_params.params[i]]) == '' ) {
        window.$Alert.alert(options.require_params.message); 
        return;
      } else {
        defaultData[options.require_params.params[i]] = options.params[options.require_params.params[i]];
      }
    }
  }

  $('#'+ grid_options.general.id)
    .alopexGrid('dataAdd', defaultData, { _index : { data : 0 } })
    .alopexGrid('startEdit',{ _index: { data : 0 } })
    .alopexGrid('focusCell', { _index : { row : 0 } }, 1);
}

// 행 삭제
const delRows = function (grid_options) {
  $('#'+ grid_options.general.id).alopexGrid('dataDelete', {_state: {selected:true}});
}

// 행 삭제 취소
const cancelDelRows = function (grid_options) {
  $('#'+ grid_options.general.id).alopexGrid('dataUndelete');
}

// 셀 수정 초기화
const resetRows = function (grid_options) {
  $('#'+ grid_options.general.id).alopexGrid('dataRestore');
}

// 그리드 편집 저장
const updateRows = function (grid_options) {
  window.$Alert.confirm('데이터를 저장하시겠습니까?')
  .then((result) => {
    if (result) {
      let id = grid_options.general.id;
      let result = $('#'+ id).alopexGrid('endEdit');
    
      if (result) {
        var updateDatas = $('#'+ grid_options.general.id).alopexGrid( 'dataGet' , { _state : { added:true } }, { _state : { added:false, edited:true } }, { _state : { added:false, edited:false, deleted:true } });

        if ( updateDatas == undefined || updateDatas == null || updateDatas == '' ) {
          window.$Alert.alert('변경된 데이터가 없습니다.')
          return;
        }

        //$('#'+ id).alopexGrid("showProgress");
        $('#'+ id).alopexGrid('dataFlush',  function(addedDataList, editedDataList, deletedDataList) {
          let params = {
            addedDataList : _.reverse(addedDataList),
            editedDataList : editedDataList,
            deletedDataList : deletedDataList
          };
    
          Vue.httpClient
          .post(grid_options.general.update, params)
          .then((result) => {
            //$('#'+ id).alopexGrid("hideProgress", true);
            // 저장 성공
            if (result.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
              // 새로 고침
              grid_options.general.PageInfo.current = 1;
              searchData(grid_options);         
            // pk 중복  
            } else if (result.data.status == AppConfig.DUP_PK) {
              window.$Alert.alert('추가하신 데이터 중<br/>이미 등록된 데이터가 있습니다.').then(() => {
                $('#'+ id).alopexGrid('startEdit',{_state: {added:true}});
              });
            // 등록 요청 목록의 pk 중복  
            } else if (result.data.status == AppConfig.DUP_REQ_PK) {             
              window.$Alert.alert('추가하신 데이터가 중복됩니다.').then(() => {
                $('#'+ id).alopexGrid('startEdit',{_state: {added:true}});
              });              
            }
          })
        }, { noCommit: true });
     
      }
    }
  })  
}

// 그리드 flag
const getGridFlag = function (value, data, mapping) {
  if (data._state.added) {
    return '추가';
  } else if (data._state.deleted) {
    return '삭제';
  } else if (data._state.edited) {
    return '수정';
  }
}

// 행추가일 경우만 편집가능
const getAddedCellEdit = function(value, data, mapping) {
  if (data._state.added) {
    return true;
  }
  return false;
}

// validation
const valid = function(value, data, mapping) {
  if ( mapping.vRules == undefined || mapping.vRules == null || mapping.vRules == '') {
    return true;
  }

  var rules = mapping.vRules.split('|');

  for ( var i in rules ) {
    // 필수 입력
    if ( rules[i] == 'require' ) {
      if(value == null || $.trim(value) == '') {
        window.$Alert.alert(mapping.title +'은(는) 필수 입력 항목입니다.');       
        return false;
      }
    // 최대 길이  
    } else if ( /max:[0-9]+/.test(rules[i]) ) {
      var max = rules[i].split(':')[1];
      if ($.trim(value) !='' && value.length > max) {
        window.$Alert.alert(mapping.title +'은(는) 최대 '+ max +'자리까지<br/>입력가능합니다.');       
        return false;
      }
    // 숫자만 입력
    } else if ( rules[i] == 'number' ) {
      if(value != null && !/^[0-9]*$/.test(value)) {
        window.$Alert.alert(mapping.title +'은(는) 숫자만 입력가능합니다.');       
        return false;
      }
    // 0 보다 큰 숫자만 입력
    } else if ( rules[i] == 'numberMoreThanZero' ) {
      if(value != null && ( !/^[0-9]*$/.test(value) || value <= 0 ) ) {
        window.$Alert.alert(mapping.title +'은(는) 0보다 큰 숫자만 입력가능합니다.');       
        return false;
      }
    }    
  }  
  
  return true;
}
// 그리드 flag
const custTypeChage = function (value, data, mapping) {
  if (value=='CC') {
    return '거래처일반';
  } else if (value=='99') {
    return '보험사';
  } else if (value=='CR') {
    return '수리공장';
  } else if (value=='SP') {
    return '스피드메이트';
  }

}

// 숫자 3자리 콤마
const numberCommaRender = function( value, data, render, mapping) {
  var len, point, str; 
       
  if ( value ) {
    value = value + ""; 
    point = value.length % 3 ;
    len = value.length; 
   
    str = value.substring(0, point); 
    while (point < len) { 
        if (str != "") str += ","; 
        str += value.substring(point, point + 3); 
        point += 3; 
    } 
  } else {
    str = value;
  }
   
  return str;
}

// data 형 format 변경 (yyyy-MM-dd)
const formatDate = function( value, data, render, mapping) {
  if ( value != null && value != '' ) {
    var d     = new Date(value),
        month = '' + (d.getMonth() + 1),
        day   = '' + d.getDate(),
        year  = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    value = [year, month, day].join('-');
  }
  
  return value;
}

export default { 
    searchData, 
    setPagingEvent, 
    setEditInvalid, 
    setDataAddColor, 
    addRow,
    delRows,
    cancelDelRows,
    resetRows,
    updateRows,
    getGridFlag,
    getAddedCellEdit,
    valid,
    custTypeChage,
    numberCommaRender,
    formatDate
} 



// WEBPACK FOOTER //
// ./src/modules/grid.js